import { FAILURE, REQUEST, SUCCESS } from 'app/shared/util/action-type.util';
import { ACTION_TYPES } from './action';
import { initialState, SellingPointState } from './state';

export default (state: SellingPointState = initialState, action): SellingPointState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_CONNECTED_SELLING_POINT):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_CONNECTED_SELLING_POINT): {
      return {
        ...state,
        connectedSellingPoint: action.payload.data,
      };
    }
    case FAILURE(ACTION_TYPES.GET_CONNECTED_SELLING_POINT): {
      return {
        ...state,
        loading: false,
      };
    }
    case REQUEST(ACTION_TYPES.UPDATE_SELLING_POINT_INFO_BANK):
      return {
        ...state,
        updateLoading: true,
        updated: false,
      };

    case SUCCESS(ACTION_TYPES.UPDATE_SELLING_POINT_INFO_BANK): {
      return {
        ...state,
        updateLoading: false,
        connectedSellingPoint: action.payload.data,
        updated: true,
      };
    }

    case ACTION_TYPES.CLEAN_UPDATED_SELLING_POINT_BANK: {
      return {
        ...state,
        updated: false,
      };
    }

    case FAILURE(ACTION_TYPES.UPDATE_SELLING_POINT_INFO_BANK): {
      return {
        ...state,
        updateLoading: false,
        updated: false,
      };
    }
    case REQUEST(ACTION_TYPES.GET_SELLING_POINT):
      return {
        ...state,
        loading: true,
        isReady: false,
      };

    case SUCCESS(ACTION_TYPES.GET_SELLING_POINT): {
      const connectedSellingPoint = state.connectedSellingPoint;
      const sellingPoints = action.payload.data;
      const selectedSellingPoint =
        connectedSellingPoint && connectedSellingPoint.code
          ? sellingPoints.find(point => point.code === connectedSellingPoint.code)
          : ({} as any);

      return {
        ...state,
        sellingPoints: action.payload.data,
        connectedSellingPoint: selectedSellingPoint,
        loading: false,
        isReady: true,
      };
    }

    case FAILURE(ACTION_TYPES.GET_SELLING_POINT): {
      return {
        ...state,
        loading: false,
        isReady: false,
      };
    }

    case ACTION_TYPES.SELECT_SELLING_POINT: {
      return {
        ...state,
        connectedSellingPoint: action.payload,
      };
    }

    default:
      return state;
  }
};
